import React from 'react';
import { Message } from './index';
import { isInternalStaff } from '../../config/navMenu';

function readUserRole() {
  try {
    return localStorage.getItem('userRole');
  } catch (e) {
    return null;
  }
}

const RelatedGuide = ({ title, courseHref, manualHref, children }) => {
  const canOpenTraining = isInternalStaff(readUserRole());
  return (
    <div className="rf-related-guide" style={{ margin: '0 0 16px' }}>
      <Message type="info">
        <strong>{title || 'Related guide'}</strong>
        <div style={{ marginTop: 6 }}>{children}</div>
        <div style={{ marginTop: 8, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {canOpenTraining && courseHref && <a href={courseHref}>Open course</a>}
          {canOpenTraining && manualHref && <a href={manualHref}>Read manual</a>}
          {!canOpenTraining && (courseHref || manualHref) && (
            <span>Related course and cell manual are not ready yet.</span>
          )}
        </div>
      </Message>
    </div>
  );
};

export default RelatedGuide;
